export const authenticationRegistry = {
  "/sign-in": {
    appName: "Abra Controls Directive 83",
    header: "FPZ Reporting",
    tagline: "Sign in to access your FPZ reports, save, share, and analyze",
    bullets: [
      "Generate new FPZ reports in a guided flow",
      "Save reports to a library for quick retrieval",
      "Share reports to collaborators and across teams",
      "Create work orders from reports to streamline operations",
    ],
    heroImageUrl: null,
    onSubmit: null,
    errorText: null,
    footerNote: "Abra Controls Directive 83",
  },
  "/login": {
    appName: "Abra Controls Directive 83",
    header: "FPZ Reporting",
    tagline: "Sign in to access your FPZ reports, save, share, and analyze",
    bullets: [
      "Generate new FPZ reports in a guided flow",
      "Save reports to a library for quick retrieval",
      "Share reports to collaborators and across teams",
      "Create work orders from reports to streamline operations",
    ],
    heroImageUrl: null,
    onSubmit: null,
    errorText: null,
    footerNote: "Abra Controls Directive 83",
  },
  "/sign-up": {
    appName: "Abra Controls Directive 83",
    header: "FPZ Reporting",
    tagline: "Create an account to view and generate FPZ reports",
    bullets: [
      "Generate new FPZ reports in a guided flow",
      "Save reports to a library for quick retrieval",
      "Share reports to collaborators and across teams",
      "View wells and directional surveys on a map and 3D rendering to enhance analysis",
      "Create work orders from reports to streamline operations",
    ],
    heroImageUrl: null,
    onSubmit: null,
    errorText: null,
    footerNote: "Abra Controls Directive 83",
  },
  // add more slugs here
};